import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';

export interface EmailStats {
  total_sent: number;
  delivered: number;
  delivery_rate: number;
  opened: number;
  open_rate: number;
  clicked: number;
  click_rate: number;
  bounced: number;
  bounce_rate: number;
  spam_reports: number;
  pending: number;
}

const KEYS = {
  all: ['emailStats'] as const,
  byPeriod: (period: string, templateId?: string) => [...KEYS.all, period, templateId] as const,
};

export const useEmailStats = (period: string = 'all', templateId?: string) => {
  return useQuery<EmailStats>({
    queryKey: KEYS.byPeriod(period, templateId),
    queryFn: async () => {
      const params: Record<string, string> = { period };
      if (templateId) params.template_id = templateId;
      const { data } = await api.get(API_ROUTES.emailStats, { params });
      return data;
    },
  });
};
